var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-stretch"},[_vm._t("addons-left"),_c('input',_vm._b({ref:"input",staticClass:"h-10 flex-1 min-w-0 border-solid border border-black/20 px-2",domProps:{"value":_vm.value},on:{"keydown":function($event){return _vm.$emit('keydown', $event)},"input":_vm.onInput}},'input',_vm.$attrs,false)),_vm._t("addons-right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }